import { Fragment } from "react/jsx-runtime";
import { RMovimentoDto } from "@/api.types";
import { agruparPorDefensoriaNucleo } from "../components/agruparPorDefensoriaNucleo";

type TabelaResumoMovimentacoesProps = {
  dados: RMovimentoDto[];
};

export function MovimentacoesPorLocalTable({ dados }: TabelaResumoMovimentacoesProps) {
  const dadosAgrupados = agruparPorDefensoriaNucleo(dados);

  function agruparPorTipo(recebimentos: any[], filtro: "civel" | "criminal") {
    const mapa = new Map<string, number>();

    recebimentos
      .filter((r) => (filtro === "civel" ? r.civel : r.criminal))
      .forEach((rec) => {
        rec.registros.forEach((reg: any) => {
          const atual = mapa.get(reg.tipo) || 0;
          mapa.set(reg.tipo, atual + Number(reg.quantidade));
        });
      });

    return Array.from(mapa.entries())
      .map(([tipo, quantidade]) => ({ tipo, quantidade }))
      .sort((a, b) => a.tipo && b.tipo ? a.tipo.localeCompare(b.tipo, "pt-BR") : 0);
  }

  // Totais gerais
  let totalGeralCivel = 0;
  let totalGeralCriminal = 0;

  return (
    <table id='movimentacoesPorLocalTable' className="table table-sm table-bordered">
      <thead>
        <tr className="table-secondary">
          <th>
            Defensoria/Núcleo
          </th>
          <th>
            Atendimentos
          </th>
        </tr>
      </thead>
      <tbody>
        {(!dadosAgrupados || dadosAgrupados.length === 0) && (
          <tr>
            <td className="text-center">
              (Nenhum registro para os filtros selecionados)
            </td>
          </tr>
        )}

        {dadosAgrupados
          .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"))
          .map((defensoria, idx) => {
            const civel = agruparPorTipo(defensoria.recebimentos, "civel");
            const criminal = agruparPorTipo(defensoria.recebimentos, "criminal");

            const totalCivel = civel.reduce((a, c) => a + c.quantidade, 0);
            const totalCriminal = criminal.reduce((a, c) => a + c.quantidade, 0);
            const totalDefensoria = totalCivel + totalCriminal;

            totalGeralCivel += totalCivel;
            totalGeralCriminal += totalCriminal;

            // alternância de cor
            //const bgClass = idx % 2 === 0 ? "table-light" : "table-secondary";

            return (
              <Fragment key={idx}>
                <tr className={"table-light"}>
                  <td colSpan={2} className="fw-bold">
                    {defensoria.nome}
                  </td>
                </tr>

                {civel.length > 0 && (
                  <>
                    <tr>
                      <td colSpan={2} className="fst-italic">Cível</td>
                    </tr>
                    {civel.map((t, i) => (
                      <tr key={i}>
                        <td className="ps-4">{t.tipo}</td>
                        <td className="text-end">{t.quantidade}</td>
                      </tr>
                    ))}
                    <tr className={`fw-bold ${"table-light"}`}>
                      <td className="ps-2">Total Cível</td>
                      <td className="text-end">{totalCivel}</td>
                    </tr>
                  </>
                )}

                {criminal.length > 0 && (
                  <>
                    <tr>
                      <td colSpan={2} className="fst-italic">Criminal</td>
                    </tr>
                    {criminal.map((t, i) => (
                      <tr key={i}>
                        <td className="ps-4">{t.tipo}</td>
                        <td className="text-end">{t.quantidade}</td>
                      </tr>
                    ))}
                    <tr className={`fw-bold ${"table-light"}`}>
                      <td className="ps-2">Total Criminal</td>
                      <td className="text-end">{totalCriminal}</td>
                    </tr>
                  </>
                )}

                <tr className={`fw-bold border-top ${"table-secondary"}`}>
                  <td>Total {defensoria.nome}</td>
                  <td className="text-end">{totalDefensoria}</td>
                </tr>
                <tr>
                  <td colSpan={2}> </td>
                </tr>
              </Fragment>
            );
          })}

        <tr className="fw-bold border-top">
          <td>Total Geral</td>
          <td className="text-end">{totalGeralCivel + totalGeralCriminal}</td>
        </tr>
      </tbody>
    </table>
  );
}
